import * as S from "sanctuary";
import * as $ from "sanctuary-def";
import { createSelector } from "reselect";
import * as R from "ramda";
import { toSentenceCase } from "@/util/common";

const INITIAL_STATE = {
  requestPending: false,
  requestError: false,
  agencies: S.Nothing,
};

export const REQUEST_AGENCIES = "currentUser/REQUEST_AGENCIES";
export const requestAgencies = () => ({
  type: REQUEST_AGENCIES,
});

export const GET_AGENCIES_STARTED = "currentUser/GET_AGENCIES_STARTED";
export const requestAgenciesStarted = () => ({
  type: GET_AGENCIES_STARTED,
});

export const GET_AGENCIES_SUCCEEDED = "currentUser/GET_AGENCIES_SUCCEEDED";
export const setAgencies = (data) => ({
  type: GET_AGENCIES_SUCCEEDED,
  payload: { data },
});

export const GET_AGENCIES_FAILED = "currentUser/GET_AGENCIES_FAILED";
export const setAgenciesError = ({ error }) => ({
  type: GET_AGENCIES_FAILED,
  payload: { error },
});

const reducer = (state = INITIAL_STATE, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case GET_AGENCIES_STARTED:
      return {
        ...state,
        requestPending: true,
      };
    case GET_AGENCIES_SUCCEEDED:
      return {
        ...state,
        requestPending: false,
        agencies: S.Just(payload.data.agencies),
        requestError: S.Nothing,
      };
    case GET_AGENCIES_FAILED:
      return {
        ...state,
        agencies: S.Nothing,
        requestPending: false,
        requestError: S.Just(payload),
      };
    default:
      return state;
  }
};

const getState = (state) => state.agencies;
export const getAgencies = (state) => getState(state).agencies;

export const getSortedServiceTypes = createSelector(
  getAgencies,
  S.map(
    S.pipe([
      S.chain((a) =>
        S.fromMaybe([])(S.get(S.is($.Array($.Object)))("serviceTypes")(a))
      ),
      (nonUnique) => R.uniqBy(S.prop("name"), nonUnique),
      S.map((serviceType) =>
        R.evolve({ description: S.map(toSentenceCase) }, serviceType)
      ),
    ])
  )
);

export const getSortedPaymentSources = createSelector(
  getAgencies,
  S.map(
    S.pipe([
      S.chain((a) =>
        S.fromMaybe([])(S.get(S.is($.Array($.Object)))("paymentSources")(a))
      ),
      (nonUnique) => R.uniqBy(S.prop("name"), nonUnique),
      S.sort,
    ])
  )
);

export const getServiceTypeDescription = createSelector(
  getSortedServiceTypes,
  (serviceTypes) => (serviceTypeKey) =>
    S.pipe([
      S.fromMaybe([]),
      S.find((st) => S.equals(serviceTypeKey)(S.prop("name")(st))),
      S.chain(S.prop("description")),
    ])(serviceTypes)
);

export const getSortedAgencies = createSelector(
  getAgencies,
  S.pipe([S.map(S.sortBy(S.prop("name")))])
);

export const getAgenciesNameList = createSelector(
  getSortedAgencies,
  S.pipe([S.fromMaybe([]), S.map(S.prop("name")), S.justs])
);

export default reducer;
